import { Component } from '@angular/core';
import {EditorialsIconComponent} from "../../../../components/icons/editorials-icon/editorials-icon.component";
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {ButtonComponent, FormBlogComponent} from "@components";

@Component({
  selector: 'wun-artist-blogs',
  imports: [
    EditorialsIconComponent,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    ButtonComponent,
    FormBlogComponent
  ],
  templateUrl: './blogs.component.html',
  styleUrl: './blogs.component.scss'
})
export class BlogsComponent {

}
